
import React, { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './Popup.scss';

const PopupForm = ({ onClose }) => {
  const popupRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    consent: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errors, setErrors] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    consent: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      isValid = false;
    }
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
      isValid = false;
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
      isValid = false;
    }
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
      isValid = false;
    }
    if (!formData.consent) {
      newErrors.consent = 'You must accept the';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const res = await fetch('http://localhost:5000/api/send-contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
        }),
      });

      if (res.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', email: '', message: '', consent: false });

        setTimeout(() => {
          setSubmitStatus(null);
          onClose();
        }, 5000);
      } else {
        const data = await res.json();
        console.error('Server error:', data.error || 'Unknown error');
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus(null), 3000);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  useEffect(() => {
    emailjs.init('LhavGRg8GYETOTOeE');
  }, []);

  return (
      <div className="popup">
        <div className="popup-inner" ref={popupRef}>
          <button className="close-btn" onClick={onClose}>
            <svg width="40" height="40" viewBox="0 0 40 40">
              <path d="M 10,10 L 30,30 M 30,10 L 10,30" stroke="white" strokeWidth="4" />
            </svg>
          </button>
          <div className="contact-form">
            <div className="contact-header">
              <h2 className="contact-us">Contact Us</h2>
              <h3 className="pre-header">Establish a contact or start describing your project right away</h3>
            </div>
            <div className="form-group form-group-inline">
              <div className="form-group-short">
                <label>{errors.name ? <span className="error-message">{errors.name}</span> : <span>Your name*</span>}</label>
                <input
                    type="text"
                    name="name"
                    placeholder="Write your name here"
                    onChange={handleChange}
                    value={formData.name}
                    className={errors.name ? 'error' : ''}
                    required
                />
              </div>
              <div className="form-group-short">
                <label>{errors.phone ? <span className="error-message">{errors.phone}</span> : <span>Your phone number*</span>}</label>
                <input
                    type="text"
                    name="phone"
                    placeholder="+358 (000) 000-00-00"
                    onChange={handleChange}
                    value={formData.phone}
                    className={errors.phone ? 'error' : ''}
                    required
                />
              </div>
              <div className="form-group-short">
                <label>{errors.email ? <span className="error-message">{errors.email}</span> : <span>Your email*</span>}</label>
                <input
                    type="email"
                    name="email"
                    placeholder="hello-there@general-kenobi.com"
                    onChange={handleChange}
                    value={formData.email}
                    className={errors.email ? 'error' : ''}
                    required
                />
              </div>
            </div>
            <div className="form-group">
              <label>{errors.message ? <span className="error-message">{errors.message}</span> : <span>Your message*</span>}</label>
              <textarea
                  name="message"
                  placeholder="Write your message: describe your future project that we can handle"
                  onChange={handleChange}
                  value={formData.message}
                  className={errors.message ? 'error' : ''}
                  required
              />
            </div>
            <div className="form-footer">
              <div className={`checkbox-group ${errors.consent ? 'error' : ''}`}>
                <label>
                  <input
                      type="checkbox"
                      name="consent"
                      checked={formData.consent}
                      onChange={handleChange}
                      required
                  />
                  {errors.consent ? <span className="error-message">{errors.consent}
                        <a href="/privacy-policy" className="error-link">Privacy Policy</a></span>
                  : <span>Please accept our
                        <a href="/privacy-policy" className="link-privacy">Privacy Policy</a></span>
                  }
                </label>
              </div>
              <div className="form-buttons">
                {/*<button type="button" className="brief-btn">Fill in the Brief</button>*/}
                <button
                    type="button"
                    className="send-btn"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Form'}
                </button>
              </div>
              {submitStatus === 'success' && (
                  <div className="submit-message success">Form submitted successfully!</div>
              )}
              {submitStatus === 'error' && (
                  <div className="submit-message error">Failed to submit the form. Please try again.</div>
              )}
            </div>
          </div>
        </div>
      </div>
  );
};

export default PopupForm;